import { Injectable } from '@angular/core';
import { ConfirmDialogService } from '../confirm-dialog.service';
import { DialogResult } from '../../../models/dialog/dialog-result.model';
import { DialogButton } from '../../../enums/dialog-button.enum';
import { MatDialog } from '@angular/material/dialog';

/**
 * A service to mock the confirm dialog service
 */
@Injectable({
  providedIn: 'root'
})
export class MockConfirmDialogService extends ConfirmDialogService {
  /**
   * @param matDialog - A reference to the MatDialog service
   */
  constructor(matDialog: MatDialog) {
    super(matDialog);
  }

  /**
   * Display a confirm dialog
   * @param title - The title of the confirm dialog
   * @param message - The message to display in the confirm dialog
   */
  public async openConfirmDialog(
    title: string,
    message: string
  ): Promise<DialogResult<null>> {
    console.log('Using mock confirm dialog service.');
    return Promise.resolve(new DialogResult<null>(DialogButton.OK));
  }
}
